import React from "react";
import PropTypes from "prop-types";
import { CreateContainer } from "./ContainerCreate";
import { getTrackMedia } from "../api/getTrack";

class MediaContainer extends React.Component {
  componentDidMount() {
    const { extUrl } = this.props;
    this.props.request(extUrl);
  }

  createTrackComment = (track) => {
    if (typeof track.comment !== "object") {
      return { __html: track.comment };
    } else {
      return track.comment;
    }
  };
  render = () => {
    const { data, loading, failure, render } = this.props;
    const track = (data && data.data) || {};
    // if (track && track.comment) {
    //   track.comment = this.createTrackComment(track);
    // }
    return render({ track, loading, failure });
  };
}

MediaContainer.propTypes = {
  extUrl: PropTypes.string.isRequired,
};

export default CreateContainer(getTrackMedia, MediaContainer);
